import React, { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { currentPatientFileInfoAtom } from "../../../Atoms/PatientFile"
import { MobergColumn, MobergDropdown, MobergInputLabel } from "../../../../../../../Moberg"
import { MAPOptAnalysis } from "../../../Types/AnalysisDetails"

type EditMAPOptProps = {
	initialState: MAPOptAnalysis
	onChange: (analysis: MAPOptAnalysis) => void
}

export const EditMAPOpt: React.FC<EditMAPOptProps> = ({ initialState, onChange }) => {
	const { patientModalities } = useRecoilValue(currentPatientFileInfoAtom)
	const sortedPatientModalities = [...patientModalities].sort()

	const [ABP, setABPModality] = useState<string>(initialState.ABP)
	const [STO2, setStO2Modality] = useState<string>(initialState.STO2)

	useEffect(() => {
		onChange({
			...initialState,
			ABP,
			STO2,
			calculationPeriodMs: 1000, // TODO: support this later.
			calculationWindowMs: 1000 // TODO: support this later.
		})
	})

	return (
		<MobergColumn gap="16px">
			<MobergColumn gap="8px">
				<MobergInputLabel text={"ABP"} />

				<MobergDropdown
					options={sortedPatientModalities.map(modality => ({ label: modality, value: modality }))}
					onChange={newValue => setABPModality(newValue)}
					selectedValue={ABP}
				/>
			</MobergColumn>

			<MobergColumn gap="8px">
				<MobergInputLabel text={"Brain Tissue Oxygen Saturation"} />

				<MobergDropdown
					options={sortedPatientModalities.map(modality => ({ label: modality, value: modality }))}
					onChange={newValue => setStO2Modality(newValue)}
					selectedValue={STO2}
				/>
			</MobergColumn>
		</MobergColumn>
	)
}
